import React from 'react'
import { Table } from 'react-bootstrap'
import Pagination from '../../../../layout/Pagination'
import dayjs from '../../../../utils/dayjsConfig'

const formatAuditTimestamp = (value) => {
  if (!value) return '-'

  return dayjs(value).local().format('DD/MM/YYYY, h:mm A')
}

const resolveActorEmail = (entry) => {
  return entry?.actor_email || entry?.actor_name || entry?.actor_uid || 'Sistema'
}

const resolveChangeType = (entry) => {
  return entry?.change_type_label || entry?.action?.toUpperCase() || '-'
}

const resolveSummary = (entry) => {
  return entry?.summary || entry?.metadata?.summary || 'Sin detalle'
}

const StoreHistoryTab = ({
  entries = [],
  loading = false,
  error = null,
  currentPage = 1,
  perPage = 25,
  totalRecords = 0,
  onPageChange
}) => {
  const totalPages = Math.ceil(totalRecords / perPage)

  const handlePaginationClick = (event) => {
    event.preventDefault()
    let target = event.target

    if (target.tagName !== 'A') {
      target = target.closest('a')
    }

    if (!target?.id || typeof onPageChange !== 'function') return

    switch (target.id) {
      case 'first-page':
        onPageChange(1)
        break
      case 'last-page':
        onPageChange(totalPages)
        break
      case 'previous-page':
        onPageChange((prev) => Math.max(1, prev - 1))
        break
      case 'next-page':
        onPageChange((prev) => Math.min(totalPages, prev + 1))
        break
      default:
        break
    }
  }

  return (
    <div>
      <h3 className="margin-text-subtitle">Historial de la relación:</h3>

      <div className="mt-20">
        <Table hover responsive>
          <thead className="table-header-gray">
            <tr>
              <th className="vertical-align-middle" style={{ padding: '10px 25px' }}>
                <span className="th-header-text">FECHA Y HORA</span>
              </th>
              <th className="vertical-align-middle">
                <span className="th-header-text">CORREO DE USUARIO</span>
              </th>
              <th className="vertical-align-middle">
                <span className="th-header-text">TIPO DE CAMBIO</span>
              </th>
              <th className="vertical-align-middle">
                <span className="th-header-text">REGISTRO NUEVO</span>
              </th>
            </tr>
          </thead>

          <tbody>
            {!loading && entries.map((entry) => (
              <tr key={entry?.id || `${entry?.created_at}-${entry?.action}`}>
                <td className="td-text-limited td-text-limited-space">
                  {formatAuditTimestamp(entry?.created_at)}
                </td>
                <td className="td-text-limited">{resolveActorEmail(entry)}</td>
                <td className="td-text-limited">{resolveChangeType(entry)}</td>
                <td className="td-text-limited">{resolveSummary(entry)}</td>
              </tr>
            ))}

            {loading && (
              <tr>
                <td colSpan="4" className="td-text-no-border">
                  Cargando historial...
                </td>
              </tr>
            )}

            {!loading && error && (
              <tr>
                <td colSpan="4" className="td-text-no-border">
                  Error cargando historial.
                </td>
              </tr>
            )}

            {!loading && !error && entries.length === 0 && (
              <tr>
                <td colSpan="4" className="td-text-no-border">
                  No hay resultados.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {totalPages > 1 && (
        <nav className="index-table store-relations-details-pagination">
          <Pagination
            current_page={currentPage}
            total_pages={totalPages}
            handle_pagination={handlePaginationClick}
          />
        </nav>
      )}
    </div>
  )
}

export default StoreHistoryTab
